import {Grid, TextField} from "@mui/material";

function ConfigurationInstances({row, index, data, setData, setEnableUpdate}: any) {

    const decimalNumber =  /^-?\d*(\.\d{0,3})?$/;

    function handleOnChange(value: any, variableName: string) {
        let originData = [...data]
        originData[index][variableName] = value;
        setData(originData)
        setEnableUpdate(true)
    }

    return (
        <Grid container columnSpacing={3}>
            <Grid item xs={3}>
                <TextField
                    fullWidth
                    variant="standard"
                    disabled={true}
                    value={row.useType}
                    InputLabelProps={{shrink: true}}
                />
            </Grid>
            <Grid item xs={3}>
                <TextField
                    fullWidth
                    value={row.typeOfRecharge}
                    disabled={true}
                    variant="standard"
                    InputLabelProps={{shrink: true}}
                />
            </Grid>
            <Grid item xs={3}>
                <TextField
                    fullWidth
                    type="number"
                    value={row.kwhPrice}
                    variant="standard"
                    onChange={e => {
                            const value = e.target.value;
                            const isMatch = decimalNumber.test(value);
                            if (isMatch || value === "") { handleOnChange(value, "kwhPrice") }
                        }
                    }
                    InputLabelProps={{shrink: true}}
                    InputProps={{
                        inputProps: {
                            style: { textAlign: "center" }
                        }
                    }}
                />
            </Grid>
            <Grid item xs={3}>
                <TextField
                    fullWidth
                    variant="standard"
                    value={row.penaltyDurationPrice}
                    type="number"
                    onChange={e => {
                            const value = e.target.value;
                            const isMatch = decimalNumber.test(value);
                            if (isMatch || value === "") { handleOnChange(e.target.value, "penaltyDurationPrice")}
                        }
                    }
                    InputLabelProps={{shrink: true}}
                    InputProps={{
                        inputProps: {
                            style: { textAlign: "center" }
                        }
                    }}
                />
            </Grid>
        </Grid>
    );
}

export default ConfigurationInstances;
